<template>
  <label class="flex items-center cursor-pointer">
    <span class="flex items-center mr-4">
      <input
        class="hidden"
        type="checkbox"
        :checked="checked"
        @change="onChange"
      />

      <i class="fal fa-square text-sm" v-show="!checked"></i>
      <i class="fas fa-check-square text-base" v-show="checked"></i>
    </span>
    {{ label }}
  </label>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: () => false,
    },

    label: {
      type: String,
      default: "",
    },
  },

  methods: {
    onChange(event) {
      this.$emit("input", event.target.checked);
    },
  },
};
</script>

<style scoped>
.fa-check-square,
.fa-square {
  @apply text-primary-purple;
}
</style>
